module.exports = __webpack_public_path__ + "img/money-dollar-circle-line.1945ca74.svg";